import $ from 'jquery';
import Features from './features';
import Swiper from './idangerous.swiper';

export default class Home {
    constructor(){
        this.tagIdx = 0;
        this.rightSlider;
        this.firstPlay = true;

        const feature = new Features();

        $('header .taglines > div').each(function () {
            feature.splitText($(this), 0);
        });

        $('header .taglines > div').eq(this.tagIdx).addClass('visible');

        $('.latest .latest-content h3 > div').each(function () {
            feature.splitText($(this), $(this).index());
            if ($(this).index() == 0) {
                $(this).addClass('visible');
            }
        });

        feature.colors('section .popular-slider li', 0, 0);
        feature.colors('.latest .latest-content .content article', 0, 1);
        feature.colors('.latest .latest-content .content.all article', 3, 1);

        $('.latest .latest-image a').first().addClass('active').parent().css('background', $('.latest .latest-content .content:not(.all) article:first-child > a').data('color'));

        this.popularSlider();
        this.delayArticles();
        this.pagination();
        this.loader();

        $(document).on('click', 'section .popular-control .popular-prev', (e) => {
            this.rightSlider.swipePrev();
        });

        $(document).on('click', 'section .popular-control .popular-next', (e) => {
            this.rightSlider.swipeNext();
        });

        $(document).on('click', '.home section.row.newsletter .form form input[type="text"], .home section.row.newsletter .form form input[type="email"]', (e) => {
            this.video();
        });

        /*
        * Affichage de tous les articles du blog sur la homepage
        */
        $(document).on('click', '.home .latest .latest-content .content .more', function () {
            $('.home .latest .latest-content h3 > div.visible').removeClass('visible').next().addClass('visible');
            $(this).parent().parent().addClass('all');

            $('.latest .latest-image .all img').each(function () {
                $(this).attr('src', $(this).data('src'));
            });

            $('html, body').animate({
                scrollTop: $('.home .latest').offset().top
            }, 800);

            var getTimeOut = $('.latest .latest-content .content.all article').length * 100;
            setTimeout(function () {
                $('.latest .latest-content .content.all article').removeAttr('style');
            }, getTimeOut);
        });

        /*
        * Animation de l'image sur le hover d'un article sur la homepage
        */
        $(document).on('mouseenter', '.latest .latest-content .content article', function () {
            $('.latest .latest-image a').removeClass('active');

            if (!$(this).parent().hasClass('all')) {
                $('.latest .latest-image > a').eq($(this).index()).addClass('active').parent().css('background', $(this).find('> a').data('color'));
            } else {
                $('.latest .latest-image .all a').eq($(this).index()).addClass('active').parent().parent().css('background', $(this).find('> a').data('color'));
            }

            $('nav #search-btn svg, nav #tag-btn svg').css('stroke', $(this).find('> a').data('color'));
            $('footer .rs a').css('background', $(this).find('> a').data('color'));
            $('aside#pagination div').css('border-color', $(this).find('> a').data('color')).find('span').css('color', $(this).find('> a').data('color'));
        });

        /*
        * Gestion bouton next slider carriere sur la homepage
        */
        $(document).on('click', '.stacked-next', function () {
            if ($('.career .slider ul > li').length > 1) {
                var getSlider = $(this).siblings('.stacked-slider');
                if (!getSlider.hasClass('is-animated')) {
                    getSlider.addClass('is-animated');
                    Zeste.main.swipeNext(getSlider);

                    setTimeout(function () {
                        getSlider.removeClass('is-animated');
                    }, 1001);
                }
            }
        });
    }
    popularSlider(){
        const feature = new Features();
        feature.colors('section .popular-slider .right .swiper-wrapper .swiper-slide', 0, 0);

        $('section .popular-control .arrow.popular-prev').addClass('disable');
        $('section .popular-slider .vertical .tags').first().show();

        $('section .popular-slider .left ul li').first().addClass('active');

        this.rightSlider = new Swiper('.popular-slider .right', {
            mode: 'horizontal',
            loop: false,
            calculateHeight: true,
            speed: 800,
            simulateTouch: false,
            onSlideChangeStart: (rightSlider) => {
                setTimeout((e) => {
                    $('section .popular-slider .left ul li').removeClass('active prev');
                    $('section .popular-slider .left ul li').eq(rightSlider.activeIndex).addClass('active').prev().addClass('prev');
                    $('section .popular-slider .vertical .tags').fadeOut();
                    $('section .popular-slider .vertical .tags').eq(rightSlider.activeIndex).fadeIn();
                }, 100);

                var setSliderColor = $(rightSlider.activeSlide())[0].children[0].dataset.color;
                $('section .popular-slider .right').css('background-color', setSliderColor);
                $('section .popular-slider .vertical .tags li a').css('color', setSliderColor);

                if (rightSlider.activeIndex > 0) {
                    $('section .popular-control .arrow.popular-prev').removeClass('disable');
                } else {
                    $('section .popular-control .arrow.popular-prev').addClass('disable');
                }

                if (rightSlider.activeIndex == $('section .popular-slider .right .swiper-wrapper .swiper-slide').length - 1) {
                    $('section .popular-control .arrow.popular-next').addClass('disable');
                } else {
                    $('section .popular-control .arrow.popular-next').removeClass('disable');
                }
            }
        });
    }
    delayArticles(){
        $('.latest .latest-content .content.all article').each(function () {
            $(this).css('transition-delay', ($(this).index() / 10) + 's');
        });
    }
    pagination(){
        var cpt = 1;
        $('.home section').each(function () {
            $('#pagination').append('<div><span>0' + cpt + '</span></div>');
            cpt++;
        });

        $('#pagination > div').first().addClass('active');
    }
    loader(){
        var vid = $('.home #loader');
        vid[0].playbackRate = 2;
        vid[0].play();
        var delay = vid[0].duration * 500 - 1000;
        setTimeout(function(){
            $('.home section').css('opacity', '1');
            vid.addClass('done');
        }, delay);
    }
    video(){
        var mov = $('.newsletter .video video')[0];

        if(this.firstPlay){
            this.firstPlay = false;
            mov.play();

            setTimeout(function(){
                mov.pause();
            }, 650);
        }
    }
}